<header class="header-container">
  <section class="header-navigation-info">
    <figure class="header-toggle-figure" (click)="toggleSideMenu()">
      <img
        class="header-toggle-image"
        src="svgs/icons/side-menu-toggle.svg"
        alt=""
      />
    </figure>
    <p class="route-title">{{ title.getTitle() | translate }}</p>
  </section>
  <section class="header-controls">
    <figure class="translation-figure" (click)="translate()">
      <img class="translation-image" [src]="langIcon" alt="" />
    </figure>
    <div class="divider"></div>
    <div class="user-info" #optionsContainer>
      <div class="controls">
        <div class="user-initials">
          <p class="name">
            {{extractInitials(loggedInUser()?.['user.name' | translate])}}
          </p>
        </div>

        <p class="username">
          {{loggedInUser()?.['name' | translate] || "Guest User" }}
        </p>
        <figure
          [ngClass]="{
            'arrow-up': isDropdownOpen(),
            'arrow-down': !isDropdownOpen()
          }"
        >
          <img src="svgs/icons/arrow-down.svg" alt="" />
        </figure>
      </div>

      @if(isDropdownOpen()){
      <div class="drop-down" id="drop-down">
        <div
          (mouseenter)="itemOnHover('logout')"
          (mouseleave)="itemOnHover(null)"
          class="drop-down-item"
          (click)="logout()"
        >
          <figure>
            <img [src]="logoutIcon()" alt="" />
          </figure>
          <p class="title">{{ "sideMenu.logout" | translate }}</p>
        </div>
      </div>
      }
    </div>
  </section>
</header>
